if (!window.SwymCallbacks) {
  window.SwymCallbacks = []
}
window.SwymCallbacks.push(function() {
  _swat.fetchWrtEventTypeET(function(products) {
    //console.log(JSON.stringify(products));
    var html = '<ul class="whislist-products">'
    $.each(products, function(i, item) {
      var pricegd = parseInt(item.pr) * parseInt(100)
      $.ajax({
        type: 'GET',
        url: item.du + '.js',
        dataType: 'json',
        async: false,
        success: function(data) {
          //console.log(JSON.stringify(data))
          var variant = data.variants,
            selecthtmp = '',
            option = data.options,
            label = 'Select option',
            select2opt = '',
            opthtml = ''
          if (option.length == 1) {
            selecthtmp += '<select name="id">'
            label = 'Select ' + option[0].name
            $.each(variant, function(k, itj) {
              selecthtmp +=
                '<option value ="' + itj.id + '">' + itj.title + '</option>'
            })
            selecthtmp += '</select>'
          } else {
            label = ''
            selecthtmp += '<select name="id" class="hidden">'
            $.each(variant, function(k, itj) {
              selecthtmp +=
                '<option data-opt="' +
                itj.option1 +
                '-' +
                itj.option2 +
                '-' +
                itj.option3 +
                '" data-option2="' +
                itj.option2 +
                '" data-option1="' +
                itj.option1 +
                '" value ="' +
                itj.id +
                '">' +
                itj.title +
                '</option>'
            })
            selecthtmp += '</select>'

            opthtml += '<div class="option-html">'
            $.each(option, function(l, ltk) {
              var values = ltk.values
              opthtml +=
                '<label>Select ' +
                ltk.name +
                '</label><select name="option' +
                ltk.position +
                '" data-option="option' +
                ltk.position +
                '">'
              $.each(values, function(m, ltkm) {
                opthtml += '<option value="' + ltkm + '">' + ltkm + '</option>'
              })
              opthtml += '</select>'
            })
            opthtml += '</div>'
          }
          //console.log(opthtml);
          html +=
            '<li><div class="remove-item" data-id="' +
            item._id +
            '"><div class="wk-icon"><svg version="1.1" xmlns="https://www.w3.org/2000/svg" width="320" height="320" viewBox="0 0 320 320"> <g> <path fill="#000000" stroke-width="0.25pt" d="m100,60l-40,40l170,170l40,-40l-170,-170z"></path> <path fill="#000000" stroke-width="0.25pt" d="m60,230l170,-170l40,40l-170,170l-40,-40z"></path></g></svg></div></div><a href="' +
            item.du +
            '"><img src=' +
            item.iu +
            '><span class="product-title">' +
            item.dt +
            '</span><span class="product-price">' +
            Shopify.formatMoney(
              pricegd,
              $('#money-format').data('money-format')
            ) +
            '</span></a><div class="addtocart-div"><form action="/cart/add" class="product_form"><label>' +
            label +
            '</label>' +
            opthtml +
            selecthtmp +
            '<input type="hidden" name="quantity" value="1"><button type="submit" name="add" class="action_button add_to_cart" data-label="Add to Cart"> <span class="text animated fadeInDown">Add to Cart</span> <svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark"> <path fill="none" stroke="#585555" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"></path></svg></button></form></li>'
        },
      })
    })
    html += '</ul>'
    $(document)
      .find('.appdend-data-here')
      .html(html)
    // render products - array of objects with same structure as productData
    // {{Insert your rendering function}}
    // products count - products.length
    if (products.length == 0) {
      $(document)
        .find('.wk-wishlist-empty-note')
        .show()
    } else {
      $(document)
        .find('.wk-wishlist-empty-note')
        .hide()
    }
    // {{Insert your count update}}

    $(document).on('change', '.option-html select', function() {
      var option1 = $(document)
          .find('select[name="option1"]')
          .val(),
        option2 = $(document)
          .find('select[name="option2"]')
          .val(),
        option3 = $(document)
          .find('select[name="option3"]')
          .val()

      if (option1 === undefined) {
        option1 = null
      }
      if (option2 === undefined) {
        option2 = null
      }
      if (option3 === undefined) {
        option3 = null
      }
      $(
        'select[name="id"] option[data-opt="' +
          option1 +
          '-' +
          option2 +
          '-' +
          option3 +
          '"]'
      ).prop('selected', true)
    })
  }, _swat.EventTypes.addToWishlist)
})
